export class HomeLobbyModel {
    activeCategory: string;
    navigationLevel: number;
    currentCategory: any;
    changeEvent: string;
    lobbyType: string;
    constructor() {}
}
